import React, { useState } from 'react'
import { Button, TextField } from '@mui/material'
function Dictionary() {
  const[Word,setWord]= useState("")
  const[meaning,setMeaning]= useState("")
  const[example,setExample]= useState("")
  const[synonyms,setSynonyms]= useState("")
  const[antonyms,setAntonyms]= useState("")



  const getMeaning=()=>{
 fetch(`https://api.dictionaryapi.dev/api/v2/entries/en/${Word}`)
 .then(res=>res.json())
 .then(json=>{
  json.map((data)=>{
    data.meanings.map((element)=>{
      element.synonyms.map((syn)=>{
   setSynonyms(syn)
      })
      element.antonyms.map((ant)=>{
        setAntonyms(ant)
           })
      element.definitions.map((each)=>{
        setMeaning(each.definition)
        setExample(each.example)
      })
    })
  })
 })
  }

  return (

    <div style={{padding:"20px" ,position:"fixed" ,top:"10%"}}>
    <div>
      <TextField  label="Word" size='small' variant="outlined" sx={{borderRadius:"20px"}} onChange={(e)=>setWord(e.target.value)}/>
      <Button variant="contained" sx={{color:"wheat",ml:"15px"}} onClick={getMeaning}>Meaning</Button>
      </div>
      <br/>
      <br/>
      <div style={{border:"2px solid wheat",width:"100%",height:"100%",borderRadius:"15px"}} >
        <h2> Meaning : {meaning ? <span>{meaning}</span>: "no records"}</h2>
        <h2> Synonyms : {synonyms ? <span>{synonyms}</span>: "no records"}</h2>
        <h2> Antonyms : {antonyms ? <span>{antonyms}</span>: "no records"}</h2>
        <h2> Example : {example ? <span>{example}</span>: "no record"}</h2>
      </div>
    </div>
  )
}

export default Dictionary
